import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@app/shared/button/button.component';
import { map, takeUntil, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ProfileService } from '@app/real-property-list-filter/services';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent],
})
export class SearchModalComponent implements OnDestroy {

  @Input() filter: any;

  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  nameControl = new FormControl();

  destroy$ = new Subject();

  constructor(
    private _messageService: MessageService,
    private _profileService: ProfileService,
  ) {}

  saveSearch() {
    if (this.nameControl.valid) {
      this._profileService
        .saveSearchSetting({ filter: this.filter, name: this.nameControl.value })
        .pipe(
          map((res) =>
            res?.status === 200 ? this._messageService.add({ severity: 'success', summary: 'Успешно сохранено' }) : this._messageService.add({ severity: 'error', summary: 'Не удалось сохранить' }),
          ),
          tap(() => this.closeEvent.emit(false)),
          takeUntil(this.destroy$),
        )
        .subscribe();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
